import { useState, useContext, useEffect } from "react";
import {
  Box,
  Stepper,
  Step,
  StepLabel,
  StepContent,
  Typography,
  RadioGroup,
  FormControlLabel,
  Radio,
} from "@mui/material";
import TemplateSelect from "./TemplateSelect";
import RecipientFilters from "./RecipientFilters";
import Recipients from "./Recipients";
import { MessengerContext } from "../../../contexts/MessengerContext";
import { EventContext } from "../../../contexts/EventContext";

const MsgStepper = ({}) => {
  const { templateId, recipientFilter, channel, setChannel } =
    useContext(MessengerContext);
  const { userData } = useContext(EventContext);
  const [smsEnabled, setSmsEnabled] = useState(false);
  const [activeStep, setActiveStep] = useState(1);

  useEffect(() => {
    if (userData && userData?.org?.config?.smsEnabled) {
      setSmsEnabled(true);
      setActiveStep(0);
    } else {
      setSmsEnabled(false);
      setActiveStep(1);
    }
  }, [userData]);
  
  useEffect(() => {
    if (templateId && !recipientFilter) {
      setActiveStep(smsEnabled ? 2 : 1);
    } else if (templateId && recipientFilter) {
      setActiveStep(smsEnabled ? 3 : 2);
    }
  }, [templateId, recipientFilter, smsEnabled]);

  return (
    <Box sx={{ marginTop: "20px" }}>
      <Stepper activeStep={activeStep} orientation="vertical">
        {smsEnabled && (
          <Step onClick={() => setActiveStep(0)}>
            <StepLabel>Choose Channel</StepLabel>
            <StepContent>
              <RadioGroup
                value={channel}
                onChange={(e) => setChannel(e.target.value)}
              >
                <FormControlLabel
                  value="email"
                  control={<Radio />}
                  label="Email"
                />
                <FormControlLabel value="sms" control={<Radio />} label="SMS" />
              </RadioGroup>
            </StepContent>
          </Step>
        )}
        <Step onClick={() => setActiveStep(smsEnabled ? 1 : 0)}>
          <StepLabel>Choose Template</StepLabel>
          <StepContent
            TransitionProps={{
              in: true,
              unmountOnExit: false,
              mountOnEnter: false,
            }}
          >
            <TemplateSelect showCustom />
          </StepContent>
        </Step>
        {templateId ? (
          <Step>
            <StepLabel>Choose Filter</StepLabel>
            <StepContent
              TransitionProps={{
                in: true,
                unmountOnExit: false,
                mountOnEnter: false,
              }}
            >
              <RecipientFilters />
            </StepContent>
          </Step>
        ) : null}

        {recipientFilter === "custom" ? (
          <Step>
            <StepLabel>Choose Recipients</StepLabel>
            <StepContent>
              <Recipients />
            </StepContent>
          </Step>
        ) : null}
      </Stepper>
    </Box>
  );
};

export default MsgStepper;
